import type { ReactNode } from 'react';

/**
 * "This figure cannot be shown right now." Used wherever a dashboard source is missing or unreachable, in place of a zero or an estimate. It names the
 * affected section's reason in plain words and may offer one setup action. It never carries a number.
 */
export function UnavailableState({
  title = 'Data unavailable', reason, action,
}: {
  title?: string | undefined;
  reason?: string | undefined;
  action?: ReactNode;
}) {
  return (
    <div className="ed-unavailable" data-testid="unavailable-state">
      <span className="ed-unavailable__icon" aria-hidden="true">⚠</span>
      <div>
        <p className="ed-unavailable__title">{title}</p>
        {reason && <p className="ed-unavailable__reason">{reason}</p>}
        {action && <div className="ed-unavailable__action">{action}</div>}
      </div>
    </div>
  );
}
